import { useEffect, useState } from "react";
import { FaTrash } from 'react-icons/fa';
import Swal from "sweetalert2";

import './cargaNequi.css'

const CargaNequitarjet = ({data,socket, dataUser})=>{
    const [mostrarInfo, setMostrarInfo] = useState(false); // Estado para mostrar/ocultar la tarjeta


   // Función para alternar el estado de visibilidad de la tarjeta
    const toggleInfo = () => {
        setMostrarInfo(!mostrarInfo);
    }
    const eliminar =async (id)=>{
        const result = await Swal.fire({
            title: "¿Estás seguro?",
            text: "Al eliminar este Tiketh, se perderá todo el proceso de recarga. si cometiste un error, puedes eliminarlo y volver a enviar",
            icon: "warning",
            showCancelButton: true,
            confirmButtonText: "Sí, eliminar",
            cancelButtonText: "Cancelar",
        });
        if (result.isConfirmed) {
            socket.emit('eliminarRecargaNequi',{
                id,
                uid:dataUser.sub
            })
        }
    }
    socket.on('ResponseAprobarNequi',(response)=>{
        Swal.fire(response.message)
    })
    // useEffect(()=>{
    //     socket.on('ResponseAprobarNequi',(response)=>{
    //         Swal.fire('alguna mierdaa pasa')
    //     })
    // },[])
    return (
        <div className="cargaNequi">
            <div className="cargaNequi-heard" onClick={toggleInfo}>
                {/* <h3>{data.id}</h3> */}
                <h3 className={data.state==='Pendiente'
                    ?'pendiente'
                    :data.state==='Cancelada'
                    ?'cancelada'
                    :'aprovada'
                }>{data.state}</h3>
            </div>
            {mostrarInfo && (
                <div className="cargaNequi-info">
                    <div className="cargaNequi-tarjeta">
                        <img src={data.comprobante} alt="123" className="cargaNequiTarjeta-img" />
                        <table className="cargaNequi-details">
                            <tbody>
                                <tr>
                                    <th>Estado:</th>
                                    <td>{data.state}</td>
                                </tr>
                                {data.state === 'Cancelada' && (
                                    <tr>
                                        <th>Motivo:</th>
                                        <th>{data.motivo}</th>
                                    </tr>
                                )}
                                <tr>
                                    <th>Fecha:</th>
                                    <td>{data.fecha}</td>
                                </tr>
                                <tr>
                                    <th>Saldo Actual:</th>
                                    <td>{data.saldoActual}</td>
                                </tr>
                                <tr>
                                    <th>Monto de Carga:</th>
                                    <td>{data.montoCarga}</td>
                                </tr>
                                <tr>
                                    <th>Opciones:</th>
                                    <td>
                                        <FaTrash onClick={()=> eliminar(data.id)} />
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            )}
        </div>
    )
}
export default CargaNequitarjet